"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAccordionSummary = exports.StyledAccordionDetails = exports.StyledValuesScrollContainer = exports.StyledAccordion = void 0;
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledAccordion = (0, styled_components_1.default)(material_1.Accordion) `
  background-color: ${ui_components_1.baseColors.background000};
`;
exports.StyledValuesScrollContainer = styled_components_1.default.div `
  max-height: 40vh;
  overflow-y: auto;
  overflow-x: hidden;

  .load-more-indicator {
    padding: ${({ theme }) => theme.spacing(1)};
  }
`;
exports.StyledAccordionDetails = (0, styled_components_1.default)(material_1.AccordionDetails) `
  display: grid;
  grid-template-rows: ${({ $rowCount = 4, $hasMeasures }) => `repeat(${$rowCount}, ${$hasMeasures ? '0fr' : '1fr'})`};
  grid-auto-columns: ${({ $itemWidth, $itemMaxWidth }) => `minmax(${$itemWidth}px, ${$itemMaxWidth}px)`};
  grid-auto-flow: column;
  overflow-x: hidden;
  gap: ${({ theme }) => theme.spacing(1)};
  padding: ${({ theme }) => theme.spacing(0, 1, 1)};

  .MuiCollapse-root {
    // use !important to override element inline styles
    transition-duration: 150ms !important;
  }
`;
exports.StyledAccordionSummary = (0, styled_components_1.default)(material_1.AccordionSummary) `
  padding: ${({ theme }) => theme.spacing(0, 0.5)};

  .MuiAccordionSummary-content {
    overflow: hidden;
    align-items: center;
    margin: ${({ theme }) => theme.spacing(1, 0)};
  }

  .expand-icon--expanded {
    transform: rotate(180deg);
  }

  .MuiAccordionSummary-expandIconWrapper {
    &.Mui-expanded {
      transform: rotate(0);
    }
  }

  .attribute-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .attribute-change-mark {
    margin-left: auto;
    margin-right: ${({ theme }) => theme.spacing(1)};
  }
`;
